<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
  export default {
    name: 'App'
  };
</script>

<style>
  #app {
    font-family:
      -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,
      'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #1c1c1e;
    height: 100vh;
    margin: 0;
    padding: 0;
    background-color: #f5f5f7;
    line-height: 1.4;
  }

  * {
    box-sizing: border-box;
  }

  body {
    margin: 0;
    padding: 0;
  }

  html.theme-dark,
  html.theme-dark body,
  html.theme-dark #app {
    background-color: #1c1c1e;
    color: #f2f2f7;
  }

  html.theme-dark .project-page {
    background-color: #1c1c1e;
  }

  html.theme-dark .project-sidebar {
    background: linear-gradient(180deg, #2c2c2e 0%, #1f1f21 100%);
    border-right-color: #3a3a3c;
  }

  html.theme-dark .sidebar-brand {
    background: linear-gradient(
      145deg,
      #0f172a 0%,
      var(--day-brand-mid) 48%,
      var(--day-brand-end) 100%
    );
    border-color: rgba(255, 255, 255, 0.14);
    box-shadow: 0 8px 20px rgba(var(--day-accent-rgb), 0.18);
  }

  html.theme-dark .sidebar-title,
  html.theme-dark .sidebar-card-title {
    color: #f2f2f7;
  }

  html.theme-dark .sidebar-subtitle {
    color: var(--day-icon);
  }

  html.theme-dark .sidebar-card:hover,
  html.theme-dark .sidebar-group-toggle.open {
    background: #3a3a3c;
    border-color: #48484a;
    box-shadow: none;
  }

  html.theme-dark .sidebar-card.active {
    background: #1e3a5f;
    border-color: #2a4a6f;
  }

  html.theme-dark .sidebar-children {
    background: rgba(28, 28, 30, 0.7);
    border-color: #3a3a3c;
  }

  html.theme-dark .sidebar-child-icon-wrap {
    background: #2c2c2e;
  }

  html.theme-dark .menu-toggle {
    color: #aeaeb2;
  }

  html.theme-dark .menu-toggle:hover {
    background-color: #3a3a3c;
    color: #64d2ff;
  }

  html.theme-dark .menu-toggle,
  html.theme-dark .menu-toggle-fixed {
    color: #f2f2f7;
    background-color: #2c2c2e;
    border-color: #3a3a3c;
  }

  html.theme-dark .menu-toggle:hover,
  html.theme-dark .menu-toggle-fixed:hover {
    background-color: #3a3a3c;
    color: #64d2ff;
  }

  html.theme-dark .sidebar-brand .menu-toggle {
    color: rgba(248, 250, 252, 0.88);
    background-color: transparent;
  }

  html.theme-dark .sidebar-brand .menu-toggle:hover {
    background-color: rgba(255, 255, 255, 0.14);
    color: #fff;
  }

  html.theme-dark .sidebar-section-label,
  html.theme-dark .sidebar-card-desc {
    color: #8e8e93;
  }

  /* Cards / panels */
  html.theme-dark .page-card,
  html.theme-dark .bg-white,
  html.theme-dark .shadow-sm.bg-white {
    background-color: #2c2c2e !important;
    border-color: #3a3a3c !important;
    color: #f2f2f7;
    box-shadow: none !important;
  }

  html.theme-dark .border-gray-200,
  html.theme-dark .border-gray-100,
  html.theme-dark .border-gray-300 {
    border-color: #3a3a3c !important;
  }

  html.theme-dark .bg-gray-50,
  html.theme-dark .hover\:bg-gray-50:hover,
  html.theme-dark .hover\:bg-gray-50:focus {
    background-color: #3a3a3c !important;
  }

  html.theme-dark .bg-white\/80 {
    background-color: rgba(44, 44, 46, 0.88) !important;
  }

  /* Text */
  html.theme-dark .text-gray-900,
  html.theme-dark .text-gray-800,
  html.theme-dark .text-gray-700,
  html.theme-dark .text-gray-600,
  html.theme-dark .page-title {
    color: #f2f2f7 !important;
  }

  html.theme-dark .text-gray-500,
  html.theme-dark .text-gray-400,
  html.theme-dark .page-subtitle {
    color: #aeaeb2 !important;
  }

  /* Form controls */
  html.theme-dark input,
  html.theme-dark select,
  html.theme-dark textarea,
  html.theme-dark .ivu-input,
  html.theme-dark .ivu-select-selection,
  html.theme-dark .ivu-input-wrapper {
    background-color: #1c1c1e !important;
    border-color: #48484a !important;
    color: #f2f2f7 !important;
  }

  html.theme-dark input::placeholder,
  html.theme-dark textarea::placeholder,
  html.theme-dark .ivu-input::placeholder {
    color: #8e8e93 !important;
  }

  html.theme-dark .ivu-form-item-label {
    color: #d1d1d6 !important;
  }

  /* Buttons */
  html.theme-dark button.border,
  html.theme-dark .ivu-btn-default {
    background-color: #3a3a3c !important;
    border-color: #48484a !important;
    color: #f2f2f7 !important;
  }

  html.theme-dark button.border:hover,
  html.theme-dark .ivu-btn-default:hover {
    background-color: #48484a !important;
  }

  /* Tables & user cards */
  html.theme-dark table {
    color: #f2f2f7;
  }

  html.theme-dark thead {
    background-color: #232326 !important;
    color: #aeaeb2 !important;
    border-bottom-color: #3a3a3c !important;
  }

  html.theme-dark tbody tr {
    border-bottom-color: #3a3a3c !important;
    color: #f2f2f7 !important;
  }

  html.theme-dark tbody tr:hover,
  html.theme-dark .hover\:bg-gray-50:hover {
    background-color: #3a3a3c !important;
  }

  html.theme-dark .user-row {
    background: #2c2c2e;
    border-color: #3a3a3c;
  }

  html.theme-dark .user-row:hover {
    border-color: #48484a;
  }

  html.theme-dark .user-name {
    color: #f2f2f7;
  }

  html.theme-dark .user-email,
  html.theme-dark .meta-label {
    color: #8e8e93;
  }

  html.theme-dark .meta-value {
    color: #e5e5ea;
  }

  html.theme-dark .divide-y > :not([hidden]) ~ :not([hidden]),
  html.theme-dark .divide-gray-100 > :not([hidden]) ~ :not([hidden]),
  html.theme-dark .divide-gray-200 > :not([hidden]) ~ :not([hidden]) {
    border-color: #3a3a3c !important;
  }

  /* Badges / chips */
  html.theme-dark .bg-slate-100 {
    background-color: #3a3a3c !important;
    color: #e5e5ea !important;
  }

  html.theme-dark .bg-violet-50 {
    background-color: #2c2440 !important;
    color: #c4b5fd !important;
  }

  html.theme-dark .bg-emerald-50 {
    background-color: #123526 !important;
    color: #6ee7b7 !important;
  }

  html.theme-dark .bg-indigo-50 {
    background-color: #1e2a4a !important;
    color: #a5b4fc !important;
  }

  html.theme-dark .text-blue-600,
  html.theme-dark .text-blue-800,
  html.theme-dark a.text-blue-600 {
    color: #64d2ff !important;
  }

  html.theme-dark .role-badge {
    background: #1e3a5f !important;
    color: #64d2ff !important;
  }

  html.theme-dark .avatar,
  html.theme-dark .avatar-empty {
    border-color: #48484a !important;
    background: #3a3a3c !important;
    color: #aeaeb2 !important;
  }

  html.theme-dark .empty-cell {
    color: #8e8e93 !important;
  }

  /* iView dropdown / select menus */
  html.theme-dark .ivu-select-dropdown,
  html.theme-dark .ivu-dropdown-menu {
    background: #2c2c2e !important;
    border-color: #3a3a3c !important;
  }

  html.theme-dark .ivu-dropdown-item,
  html.theme-dark .ivu-select-item {
    color: #f2f2f7 !important;
  }

  html.theme-dark .ivu-dropdown-item:hover,
  html.theme-dark .ivu-select-item:hover,
  html.theme-dark .ivu-select-item-selected {
    background: #3a3a3c !important;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue